export const STAMP_COUNT = 6
export const STAMP_DELAY_STEP = 90
export const STAMP_FLIGHT_MS = 900
export const STAMP_CLOSE_BUFFER_MS = 250
export const STAMP_TOTAL_MS =
  (STAMP_COUNT - 1) * STAMP_DELAY_STEP + STAMP_FLIGHT_MS + STAMP_CLOSE_BUFFER_MS

export type Viewport = { width: number; height: number }
export type StampAnchor = {
  left: number
  top: number
  width: number
  height: number
}
export type StampPoint = { x: number; y: number }

export type FlyingStamp = {
  id: number
  startX: number
  startY: number
  dx: number
  dy: number
  offsetX: number
  delay: number
}

export function flyingStampsFrom(
  anchor: StampAnchor | null,
  target: StampPoint,
  viewport: Viewport,
): FlyingStamp[] {
  const startX = anchor ? anchor.left + anchor.width / 2 : viewport.width / 2
  const startY = anchor ? anchor.top + anchor.height * 0.4 : viewport.height / 2
  const dx = target.x - startX
  const dy = target.y - startY
  return Array.from({ length: STAMP_COUNT }, (_, i) => ({
    id: i,
    startX,
    startY,
    dx,
    dy,
    offsetX: (i - (STAMP_COUNT - 1) / 2) * 16,
    delay: i * STAMP_DELAY_STEP,
  }))
}
